import { useMemo } from 'react';
import classNames from 'classnames';
import { Section } from '@/components';
import { ReactComponent as LogoSignum } from '@/assets/images/signum.svg';
import { ReactComponent as IconMediacion } from '@/assets/images/mediacion.svg';
import { ReactComponent as IconArbitraje } from '@/assets/images/arbitraje.svg';

type FNSignumProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-fnsignum';

export const FNSignum = ({ className }: FNSignumProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);

	return (
		<Section className={wrapperClassName}>
			<div className={`${classNameComponent}__box`}>
				{/* Fila 1: hero */}
				<div className={`${classNameComponent}__hero`}>
					<div className={`${classNameComponent}__logo`}>
						<LogoSignum aria-hidden="true" />
					</div>
					<div className={`${classNameComponent}__hero-copy`}>
						<h2 id="fnsignum-title" className={`${classNameComponent}__title`}>
							Fundación notarial SIGNUM
						</h2>
						<p className={`${classNameComponent}__intro`}>
							La Fundación tiene como objetivo poner al alcance de toda la sociedad un nuevo servicio, que
							permita el acceso a nuevas formas dinámicas de resolución de conflictos, asequibles,
							eficaces, confidenciales y con todas las garantías jurídicas.
						</p>
					</div>
				</div>
				<div className={`${classNameComponent}__cards`}>
					<article className={`${classNameComponent}__card`}>
						<IconMediacion className={`${classNameComponent}__icon`} aria-hidden="true" />
						<div>
							<h3 className={`${classNameComponent}__card-title`}>Mediación</h3>
							<p className={`${classNameComponent}__card-desc`}>
								La mediación es un método que permite la resolución de conflictos de manera pacífica, a
								través del diálogo entre las partes implicadas.
							</p>
						</div>
					</article>

					<article className={`${classNameComponent}__card`}>
						<IconArbitraje className={`${classNameComponent}__icon`} aria-hidden="true" />
						<div>
							<h3 className={`${classNameComponent}__card-title`}>Arbitraje</h3>
							<p className={`${classNameComponent}__card-desc`}>
								Es un proceso en el cual se trata de resolver extrajudicialmente las diferencias que
								surjan en las relaciones entre dos o más partes.
							</p>
						</div>
					</article>
				</div>
			</div>
		</Section>
	);
};
